import { ARTICLE_DATA_PAGE_TYPE } from "~constants";
import { ARTICLE_TYPE, Story, StoryCollections } from "~types/types";

const getCollectionsTracking = (collections?: StoryCollections) => {
    if (collections?.recordId && collections?.weekendId) {
        return `record_${collections?.recordId},weekend_${collections?.weekendId}`;
    }

    if (collections?.recordId) {
        return `record_${collections?.recordId}`;
    }

    if (collections?.weekendId) {
        return `weekend_${collections?.weekendId}`;
    }
    return null;
};

export const getGtmTrackingData = (content: Story) => {
    const {
        adTargeting,
        archived,
        attributor,
        brand,
        byline,
        categories,
        cobrand,
        collections,
        franchise,
        headline,
        id,
        metadata,
        publishedAt,
        resourceType,
        site,
        slug,
        type,
        pillar,
        tags,
    } = content;

    const templateType = archived ? "archived" : type;
    const template =
        type === "article" || type === "feature"
            ? ARTICLE_DATA_PAGE_TYPE[type as ARTICLE_TYPE]
            : `${
                  ARTICLE_DATA_PAGE_TYPE[type as ARTICLE_TYPE]
              }-${templateType?.toLowerCase()}`;

    const [mostRelevantTopic] = tags || [];

    return {
        adcode: adTargeting?.adCode,
        attributor,
        author: byline,
        brand,
        categories,
        collections: getCollectionsTracking(collections),
        contentType: `content-${type}`,
        editorialPillar: pillar,
        franchise,
        generalTestingId: null,
        generalTestingName: null,
        headline,
        pageType: "content",
        publishedAt,
        registrationWall: metadata?.registrationWall,
        resourceId: id,
        resourceType,
        secondaryBrands: cobrand,
        siteId: site,
        slug,
        storyId: id,
        tags: "",
        template,
        transporter: "false",
        topic: mostRelevantTopic?.name || "",
    };
};
